import type { Locale } from "../../core/schema/Locale.js";
import type { TenantId } from "../../core/schema/Tenant.js";

export const globalSettingsContextKey = "globalSettings";

export interface GlobalSettings {
	ALGOLIA_API_SEARCH_KEY: string;
	ALGOLIA_APP_ID: string;
	COOKIES: string;
	DOMAIN: string;
	ENV: string;
	ENV_DOMAIN: string;
	GOOGLE_ANALYTICS: string;
	GOOGLE_TAG_MANAGER: string;
	PROJECT: string;
	PUBLIC_GRAPHQL_ENDPOINT: string;
	ROBOTS: "index" | "noindex";
	STORAGE_URL: string;
	TENANT_ID: TenantId;
	TENANT_LOCALE: Locale;
	UPLOAD_URL: string;
	VERSION: string;
	WEB_URL: string;
}
